// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eAJq","newExpiryDate":"styles_newExpiryDate__2eVR8","footer":"styles_footer__Fbpoj"};